import { styled, Button, Dialog, Box } from '@mui/material';

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  width: '200px',
  height: '48px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  width: '200px',
  height: '48px',
  color: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '800px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 700,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));
